import React, { useEffect, useState, useRef, useContext } from "react";
import { StyledContainer } from "./styles";
import classnames from "classnames";
import Textarea from "react-textarea-autosize";
import Card, { DEFAULT_CARD_SIZE } from "..";
import { CardContext } from "../..";
import { SET_CONTENT_ACTION } from "../../hooks/useCanvasReducer";

const MAX_CHARACTER_COUNT = 2500;

function EditableTextCard({
  x, //
  y,
  content,
  width,
  height,
  id,
  selected,
  type,
  zoom,
  generating,
  index,
  initialEditing = false,
  autoHeight,
}) {
  const {
    selectedCardIds, //
    setIsEditing,
    setContent,
    isSpaceDown,
    dispatch,
  } = useContext(CardContext);

  const [editing, setEditing] = useState(initialEditing);

  const editingRef = useRef(null);

  // true if this is the only card selected
  const onlyThisSelected = selected && selectedCardIds.length === 1;

  // upon selection logic
  useEffect(() => {
    if (!onlyThisSelected) {
      if (editingRef.current) {
        editingRef.current.blur();
      }
      setEditing(false);
    }
  }, [selected, selectedCardIds]);

  // on edit start, focus and place cursor at end
  useEffect(() => {
    if (editing && editingRef.current) {
      editingRef.current.focus();
      editingRef.current.selectionStart = editingRef.current.value.length;
    }
  }, [editing]);

  return (
    <Card
      onEditIntent={(e) => {
        if (onlyThisSelected) {
          // on the second click, we allow editing
          setEditing(true);
        }
      }}
      x={x}
      y={y}
      content={content}
      width={width}
      height={height}
      minSize={autoHeight ? DEFAULT_CARD_SIZE : null} // if the user has touched the card and no longer auto height, then we relax the minsize
      id={id}
      selected={selected}
      type={type}
      zoom={zoom}
      generating={generating}
      generatable={content?.length > 0}
      index={index}
      autoHeight={autoHeight}
    >
      <StyledContainer className={classnames("textarea-container", { editing: editing })}>
        <Textarea
          maxLength={MAX_CHARACTER_COUNT}
          placeholder="Add text"
          className={classnames("editable", { "edit-on": editing })}
          ref={editingRef}
          disabled={!editing || isSpaceDown}
          onChange={(e) => {
            dispatch({ type: SET_CONTENT_ACTION, id: id, content: e.target.value });
            e.stopPropagation();
          }}
          onBlur={(e) => setIsEditing(false)}
          onFocus={(e) => setIsEditing(true)}
          value={content}
        />
      </StyledContainer>
    </Card>
  );
}

export default EditableTextCard;
